module.exports = __webpack_public_path__ + "img/guess_left_sel.a7604400.png";